import React from 'react';
import { OverlayTrigger, Stack, Tooltip } from 'react-bootstrap';
import { FaCheck, FaHourglass, FaTimes } from 'react-icons/fa';

export type overrideStatusType = 'approved' | 'pending' | 'denied';

type OverrideStatusSource = {
  id?: number;
  status?: overrideStatusType;
  override_approved?: boolean | number | string | null;
  denial_notes?: string | null;
  approved_at?: string | Date | null;
};

const isOverrideApproved = (override: OverrideStatusSource): boolean =>
  override.override_approved === true ||
  override.override_approved === 1 ||
  override.override_approved === '1' ||
  !!override.approved_at;

const isOverrideDenied = (override: OverrideStatusSource): boolean =>
  override.override_approved === false ||
  override.override_approved === 0 ||
  override.override_approved === '0' ||
  (!!override.denial_notes && !isOverrideApproved(override));

export const getOverrideStatus = (
  override?: OverrideStatusSource | null
): overrideStatusType | null => {
  if (!override?.id) return null;
  if (isOverrideApproved(override)) return 'approved';
  if (isOverrideDenied(override)) return 'denied';
  return 'pending';
};

interface OverrideStatusCellProps {
  type: overrideStatusType;
  value: string;
  notes?: string;
}

export const OverrideStatusCell: React.FC<OverrideStatusCellProps> = ({ type, value, notes }) => {
  const renderTooltip = (props: any) => (
    <Tooltip
      id="override-tooltip"
      {...props}
    >
      <span style={{ fontSize: '.75rem' }}>
        Override #{value} {type === 'pending' ? 'is' : 'has been'} {type}{' '}
        {notes ? `: ${notes}` : ''}.
      </span>
    </Tooltip>
  );

  return (
    <Stack
      direction="horizontal"
      gap={2}
      className="align-items-center"
    >
      <OverlayTrigger
        overlay={renderTooltip}
        placement="bottom"
      >
        <Stack
          direction="horizontal"
          gap={2}
          className="align-items-center"
          style={{ cursor: 'pointer' }}
        >
          {type === 'approved' ? (
            <FaCheck size={19} />
          ) : type === 'denied' ? (
            <FaTimes size={22} />
          ) : (
            <>
              <FaHourglass size={22} />
              <span>Pending</span>
            </>
          )}
        </Stack>
      </OverlayTrigger>
    </Stack>
  );
};
